"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpenDaysForShift = exports.sortShiftByPaymentType = void 0;
const date_fns_1 = require("date-fns");
function sortShiftByPaymentType(data) {
    var _a;
    const paymentTypeOrder = {
        card: 1,
        cash: 2,
        online: 3,
    };
    data &&
        ((_a = data.salesByPaymentType) === null || _a === void 0 ? void 0 : _a.sort((a, b) => {
            var _a, _b;
            return (paymentTypeOrder[(_a = a.paymentType.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()] -
                paymentTypeOrder[(_b = b.paymentType.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()]);
        }));
    return data;
}
exports.sortShiftByPaymentType = sortShiftByPaymentType;
// This function find out the open days for the shift based on the start time of the report settings from backoffice config
const getOpenDaysForShift = (shiftCreatedTimestamp, startTradingTime) => {
    const currentDay = (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd');
    const currentTimeStamp = new Date(`${currentDay} 23:59`).getTime();
    let shiftCreatedRecurringTime = shiftCreatedTimestamp;
    let shiftOpenDays = 0;
    for (let i = 0; shiftCreatedRecurringTime < currentTimeStamp; i++) {
        const tradeDate = (0, date_fns_1.format)(new Date(shiftCreatedRecurringTime), 'yyyy-MM-dd');
        const tradeDateTime = new Date(`${tradeDate} ${startTradingTime}`);
        const tradeStartTime = tradeDateTime.getTime();
        const tradeEndTime = (0, date_fns_1.add)(tradeDateTime, { days: 1 }).getTime();
        const now = new Date().getTime();
        // This condition check the shift created time and start reporting time from the shift created day to until today
        // If shift created time not falls in the range then we're increasing the open days count
        if (!(shiftCreatedTimestamp >= tradeStartTime &&
            shiftCreatedTimestamp < tradeEndTime) &&
            now > tradeStartTime) {
            shiftOpenDays += 1;
        }
        shiftCreatedRecurringTime = (0, date_fns_1.add)(new Date(shiftCreatedRecurringTime), {
            days: 1,
        }).getTime();
    }
    return shiftOpenDays;
};
exports.getOpenDaysForShift = getOpenDaysForShift;
//# sourceMappingURL=shifts.js.map